import { atom } from 'jotai';

export const emailAtom = atom<string | null>(null);
export const userFirstNameAtom = atom<string | null>(null);
export const userLastNameAtom = atom<string | null>(null);
export const userRoleAtom = atom<string | null>(null);
export const hasActiveAdminAtom = atom<boolean>(false);
export const companyIdAtom = atom<string | null>(null);
export const companyNameAtom = atom<string | null>(null);
